import React, { useState, useEffect } from 'react';
import ClinicNotificationsMobile from './clinicNotificationsMobile';
import ClinicNotificationsWeb from './clinicNotificationsWeb';

const MOBILE_BREAKPOINT = 768;

const useWindowWidth = () => {
  const [windowWidth, setWindowWidth] = useState(window.innerWidth);

  useEffect(() => {
    const handleResize = () => setWindowWidth(window.innerWidth);
    window.addEventListener('resize', handleResize);

    return () => window.removeEventListener('resize', handleResize);
  }, []);

  return windowWidth;
};

export default function ClinicNotificationsRouter() {
  const width = useWindowWidth();

  return width < MOBILE_BREAKPOINT ? <ClinicNotificationsMobile /> : <ClinicNotificationsWeb />;
}
